import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import type { CheckInData } from './types';

export const CHECK_IN_TABLE_COLUMNS: ColumnsType<CheckInData> = [
  {
    title: '育樂日期',
    dataIndex: 'programDate',
    render: (programDate) => dayjs(programDate).format('YYYY/MM/DD'),
    sorter: (a, b) => a.programDate - b.programDate,
  },
  {
    title: '育樂類別',
    dataIndex: 'programCategory',
  },
  {
    title: '育樂名稱',
    dataIndex: 'programName',
  },
  {
    title: '手機號碼',
    dataIndex: 'phoneNumber',
    render: (phoneNumber) =>
      phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, '$1-$2-$3'),
  },
  {
    title: '會員',
    dataIndex: 'memberName',
  },
  {
    title: '狀態',
    dataIndex: 'status',
  },
  {
    title: '簽到時間',
    dataIndex: 'checkInTime',
    render: (checkInTime) =>
      checkInTime ? dayjs(checkInTime).format('YYYY/MM/DD HH:mm') : null,
    sorter: (a, b) => {
      if (!a.checkInTime && !b.checkInTime) return 0;
      if (!a.checkInTime) return 1;
      if (!b.checkInTime) return -1;
      return a.checkInTime - b.checkInTime;
    },
  },
  {
    title: '訂單編號',
    dataIndex: 'orderNumber',
  },
  {
    title: '下單時間(年/月/日)',
    dataIndex: 'orderedTime',
    render: (orderedTime) => dayjs(orderedTime).format('YYYY/MM/DD HH:mm:ss'),
    sorter: (a, b) => a.orderedTime - b.orderedTime,
  },
  {
    title: '付費方式',
    dataIndex: 'payment',
  },
  {
    title: '金額',
    dataIndex: 'price',
    render: (price, record) => {
      if (record.payment === '點數') {
        return `${price}點`;
      }
      return `${price}元`;
    },
  },
];

// TODO: 這裡之下都是測試用資料，記得刪除

export const PROGRAM_OPTIONS = [
  { label: '創意手工芳香皂', value: '創意手工芳香皂' },
  { label: '陶藝製作基礎班', value: '陶藝製作基礎班' },
  { label: '咖啡烘焙與品鑑', value: '咖啡烘焙與品鑑' },
  { label: '花藝設計與插花', value: '花藝設計與插花' },
  { label: '烘焙甜點製作', value: '烘焙甜點製作' },
  { label: '瑜珈與冥想課程', value: '瑜珈與冥想課程' },
  { label: '手作皮革工藝', value: '手作皮革工藝' },
  { label: '水彩繪畫技法', value: '水彩繪畫技法' },
  { label: '攝影基礎與構圖', value: '攝影基礎與構圖' },
  { label: '手沖咖啡技巧', value: '手沖咖啡技巧' },
  { label: '園藝與植栽設計', value: '園藝與植栽設計' },
];

export const DUMMY_CHECK_IN_TABLE_DATA: CheckInData[] = [
  {
    _id: '1',
    programDate: 1705593600000,
    programCategory: '技藝',
    programName: '創意芳香手工皂',
    phoneNumber: '0988888888',
    memberName: '林大華',
    status: '未簽到',
    checkInTime: null,
    orderNumber: '20230202120087',
    orderedTime: 1700107200000,
    payment: '信用卡',
    price: 200,
  },
  {
    _id: '2',
    programDate: 1705593600000,
    programCategory: '技藝',
    programName: '創意芳香手工皂',
    phoneNumber: '0978987486',
    memberName: '王小明',
    status: '已簽到',
    checkInTime: 1705647600000,
    orderNumber: '20230202120166',
    orderedTime: 1700107200000,
    payment: '點數',
    price: 200,
  },
];
